import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { Connector } from '@portal-core/publications/models/connector.model';

@CollectionStateSelectors({
  stateType: ConnectorState
})

@State<ConnectorState>({
  name: ConnectorState.source,
})

@Injectable()
export class ConnectorState extends CollectionStateBase {
  static source: string = 'Connector';

  getSource(): string {
    return ConnectorState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConnectorDataService extends CollectionDataServiceBase<Connector> {
  constructor(protected store: Store) {
    super(store, ConnectorState);
  }
}
